<template>
  <div class="edit-container">
    <div class="wallet-type">
      <p class="title">{{ divWalletTitle }}</p>
      <ul class="items">
        <li
          v-for="(item, index) in walletType"
          :key="index"
          class="item"
          :class="{ disabled: item.disabled }"
        >
          <div>
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
    <div>
      <div class="input-wrap">
        <input-module :data="nickData" />
      </div>
      <input-module :data="addrData" />
      <input-module :data="ciNameData" />
    </div>
    <div class="button-wrap">
      <button @click="clickToBack" class="button pre">이전</button>
      <button @click="showModal" class="button next">삭제하기</button>
    </div>
    <small-modal :title="modalTitle" :data="modalData" @confirm="confirm">
      <div class="modal-contents ta-c">
        <p>
          <span>{{ channelData.value }}</span> {{ nickData.value }}
        </p>
        <p>{{ addrData.value }}</p>
        <p>개인지갑 주소를 삭제하시겠습니까?</p>
      </div>
    </small-modal>
  </div>
</template>
<script>
import inputModule from "./component/inputModule.vue";
import smallModal from "./component/smallModal.vue";
import Api from "@/common/Api";

export default {
  components: {
    inputModule,
    smallModal,
  },
  created() {
    if (!this.$route.params.addrInfo) {
      this.$router.push({ name: "authAddress" });
    }
  },
  data() {
    return {
      nickData: {
        title: "별칭",
        value: this.$route.params.addrInfo.nick,
        disabled: true,
      },
      addrData: {
        title: "지갑 주소",
        value: this.$route.params.addrInfo.address,
        disabled: true,
      },
      ciNameData: {
        title: "네트워크 / 가상자산",
        value: this.$route.params.networkInfo,
        disabled: true,
      },
      channelData: {
        title: "네트워크",
        value:
          this.$route.params.addrInfo.channel === "M"
            ? "[메타마스크]"
            : "[개인지갑]",
        disabled: true,
      },
      divWalletTitle: "지갑 구분",
      walletType: [
        {
          name: "메타마스크",
          disabled: false,
        },
        {
          name: "카카오클립",
          disabled: true,
        },
        {
          name: "페이코인 월렛",
          disabled: true,
        },
      ],
      modalTitle: "주소 삭제",
      modalData: {
        showModal: false,
        cancel: "취소",
        confirm: "확인",
      },
    };
  },
  methods: {
    clickToBack() {
      this.$router.push({ name: "authAddress" });
    },
    showModal() {
      this.modalData.showModal = true;
    },
    async confirm() {
      try {
        const params = {
          acaidx: this.$route.params.addrInfo.acaidx,
        };
        await Api.authAddr.deleteAddresses(params);
        this.modalData.showModal = false;
        this.$router.push({ name: "authAddress" });
      } catch (error) {
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: error.msg,
          position: "top-left",
          color: "danger",
        });
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/color_palette.scss";

.edit-container {
  padding: 16px;
  font-size: 14px;
  &.mid {
    position: relative;
  }
  .wallet-type {
    margin-bottom: 20px;
    ul.items {
      display: flex;
      flex-direction: row;
      justify-content: stretch;
      li.item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 44px;
        text-align: center;
        border: 1px solid $Red500;
        border-radius: 4px;
        margin-right: 10px;
        color: $BlueGray100;
        background-color: $Red500;
        &:last-of-type {
          margin-right: 0;
        }
        &.disabled {
          border: 1px solid $BlueGray600;
          background-color: $BlueGray300;
          color: $BlueGray600;
        }
      }
    }
  }
  .input-wrap {
    position: relative;
    .check-length {
      position: absolute;
      bottom: 24px;
      right: 12px;
      color: $BlueGray600;
    }
  }
  .button-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    .button {
      min-height: 44px !important;
      border: 1px solid $BlueGray600;
      border-radius: 4px;
      &.pre {
        width: 96px;
      }
      &.next {
        width: calc(100% - 104px);
        border-color: $Cobalt500;
        background-color: $Cobalt500;
        color: $BlueGray100;
      }
    }
  }
  .modal-contents {
    padding: 16px;
    p {
      word-break: break-all;
    }
  }
}
</style>
